import { Phone, Mail, Instagram, Globe, MapPin, Clock } from "lucide-react";

const channels = [
  {
    icon: Phone,
    label: "Phone / Text",
    value: "021 109 7531",
    href: "tel:+64211097531",
    test: "contact-phone",
  },
  {
    icon: Mail,
    label: "Email",
    value: "amber.rufer@gmail.com",
    href: "mailto:amber.rufer@gmail.com",
    test: "contact-email",
  },
  {
    icon: Instagram,
    label: "Instagram",
    value: "@ambers_mobilebeauty",
    href: "https://www.instagram.com/ambers_mobilebeauty",
    test: "contact-instagram",
  },
  {
    icon: Globe,
    label: "Website",
    value: "ambersbeauty.co.nz",
    href: "https://ambersbeauty.co.nz",
    test: "contact-website",
  },
];

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#FAEDE6] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-8 bg-[#B78782]" />
              <span className="text-[11px] tracking-[0.4em] uppercase text-[#B78782]">
                Enquire
              </span>
            </div>
            <h2 className="font-serif-display text-[#4A3737] text-4xl md:text-5xl lg:text-[64px] font-light leading-[1.02] tracking-tight">
              Let's plan your
              <br />
              <em className="not-italic font-script text-[#B78782] text-5xl md:text-6xl lg:text-[68px]">
                next ritual.
              </em>
            </h2>
            <p className="mt-8 max-w-md text-[15px] leading-relaxed text-[#4A3737]/80 font-light">
              Reach out by phone, email or Instagram and Amber will reply
              personally — usually the same day — with availability, pricing
              and a tailored treatment recommendation.
            </p>

            <div className="mt-10 flex flex-col gap-3 max-w-md">
              <div className="flex items-start gap-3 text-[#4A3737]/85 text-sm">
                <MapPin size={16} className="text-[#B78782] mt-1" strokeWidth={1.5} />
                <div>
                  <p className="text-[11px] tracking-[0.32em] uppercase text-[#B78782] mb-1">
                    Service Area
                  </p>
                  <p className="font-light">Auckland-wide · in the comfort of your home</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-[#4A3737]/85 text-sm mt-4">
                <Clock size={16} className="text-[#B78782] mt-1" strokeWidth={1.5} />
                <div>
                  <p className="text-[11px] tracking-[0.32em] uppercase text-[#B78782] mb-1">
                    Hours
                  </p>
                  <p className="font-light">By appointment</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <ul className="divide-y divide-[#B78782]/25 border-y border-[#B78782]/25">
              {channels.map(({ icon: Icon, label, value, href, test }) => (
                <li key={label}>
                  <a
                    href={href}
                    target={href.startsWith("http") ? "_blank" : undefined}
                    rel={href.startsWith("http") ? "noreferrer" : undefined}
                    data-testid={test}
                    className="group flex items-center gap-6 py-7 hover:bg-[#F9F5F0] transition-colors duration-300 px-2 -mx-2"
                  >
                    <Icon
                      size={20}
                      strokeWidth={1.25}
                      className="text-[#B78782] group-hover:scale-110 transition-transform duration-300"
                    />
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] tracking-[0.32em] uppercase text-[#4A3737]/60 mb-1.5">
                        {label}
                      </p>
                      <p className="font-serif-display text-2xl md:text-[28px] font-light text-[#4A3737] group-hover:text-[#B78782] transition-colors duration-300 truncate">
                        {value}
                      </p>
                    </div>
                    <span className="hidden md:inline text-[11px] tracking-[0.28em] uppercase text-[#B78782] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      Open →
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
